var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import { getSheetPrice } from 'ts/modules/pricing';
import { sheetDelivery } from 'ts/modules/delivery';
import { validateSheet } from 'ts/modules/validation';
let GlazingOption = class GlazingOption extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.price = "0.00";
        this.manufacture = {
            isValid: true,
            problems: [],
            warnings: []
        };
        this.delivery = {
            isValid: true,
            problems: [],
            warnings: []
        };
        this.debouncedUpdate = debounce(this.update, 350);
    }
    get glassDimensions() {
        return {
            width: this.rebateDimensions.width - 3,
            length: this.rebateDimensions.length - 3
        };
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            yield Promise.all([
                this.updatePrice(),
                this.validateManufacture(),
                this.validateDelivery()
            ]);
            this.loading = false;
        });
    }
    updatePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            let price = yield getSheetPrice(`G-${this.glazing.id}`, this.glassDimensions, true);
            this.price = price.base_unit_price;
        });
    }
    validateManufacture() {
        return __awaiter(this, void 0, void 0, function* () {
            this.manufacture = yield validateSheet(this.glazing.sku, this.glassDimensions, true);
        });
    }
    validateDelivery() {
        return __awaiter(this, void 0, void 0, function* () {
            this.delivery = yield sheetDelivery(this.glazing.sku, this.glassDimensions, true);
        });
    }
    mounted() {
        this.update();
    }
};
__decorate([
    Prop({ type: Object })
], GlazingOption.prototype, "glazing", void 0);
__decorate([
    Prop({ type: Object })
], GlazingOption.prototype, "rebateDimensions", void 0);
__decorate([
    Watch('rebateDimensions', { deep: true })
], GlazingOption.prototype, "debouncedUpdate", void 0);
GlazingOption = __decorate([
    Component({
        components: {
            BRow, BCol
        }
    })
], GlazingOption);
export default GlazingOption;
